import {
  REGISTER_TOKENCA_FAILED,
  REGISTER_TOKENCA_SUCCESS,
} from 'redux/actions';
import { IAction, IReducerState } from 'interfaces/common';

export function RegisterTokenCA(
  state: IReducerState<any> = { data: null, status: {} },
  action: IAction<any>
) {
  switch (action.type) {
    case REGISTER_TOKENCA_SUCCESS:
      return {
        status: {
          isSucceeded: true,
        },
      };

    case REGISTER_TOKENCA_FAILED:
      return {
        status: {
          isFailed: true,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/global-reducers/RegisterTokenCA.ts